export var MixpanelEvents;
(function (MixpanelEvents) {
    // Server
    MixpanelEvents["Login"] = "Login";
    MixpanelEvents["SignUp"] = "SignUp";
    MixpanelEvents["OrganisationConnected"] = "OrganisationConnected";
    MixpanelEvents["OrganisationDisconnected"] = "OrganisationDisconnected";
    MixpanelEvents["TrialStarted"] = "TrialStarted";
    MixpanelEvents["TrialToPaidConversion"] = "TrialToPaidConversion";
    MixpanelEvents["CancelledToPaidConversion"] = "CancelledToPaidConversion";
    MixpanelEvents["TrialExpired"] = "TrialExpired";
    MixpanelEvents["PlanPaidUpfront"] = "PlanPaidUpfront";
    MixpanelEvents["PlanCancelled"] = "PlanCancelled";
    MixpanelEvents["OrganisationLinkedPlan"] = "OrganisationLinkedPlan";
    MixpanelEvents["TestEmailSent"] = "TestEmailSent";
    MixpanelEvents["PinchPaymentEnabled"] = "PinchPaymentEnabled";
    MixpanelEvents["PinchPaymentDisabled"] = "PinchPaymentDisabled";
    MixpanelEvents["PinchPaymentLinkClicked"] = "PinchPaymentLinkClicked";
    MixpanelEvents["SafeModeDisabled"] = "SafeModeDisabled";
    MixpanelEvents["PricingPageViewed"] = "PricingPageViewed";
    MixpanelEvents["SubscriptionCheckoutStarted"] = "SubscriptionCheckoutStarted";
    MixpanelEvents["FirstCompleteAction"] = "FirstCompleteAction";
    // Client
    MixpanelEvents["AppLoaded"] = "App Loaded";
    MixpanelEvents["PortalLoaded"] = "Portal Loaded";
    MixpanelEvents["InAppDemoCallClicked"] = "In App Demo Call Clicked";
    MixpanelEvents["WelcomeModalDemoClicked"] = "Welcome Modal Demo Clicked";
    MixpanelEvents["PortalPageLoaded"] = "Portal Page Loaded";
    MixpanelEvents["PortalInvoiceNotFound"] = "Portal Invoice Not Found";
    MixpanelEvents["PortalInvoiceXeroClicked"] = "Portal Invoice Xero Clicked";
    MixpanelEvents["OnboardingCompleted"] = "Onboarding Completed";
    MixpanelEvents["OnboardingSkipped"] = "Onboarding Skipped";
    MixpanelEvents["DashboardSendReminderNowClick"] = "Dashboard Send Reminder Now Click";
    MixpanelEvents["DashboardChargeInterestNowClick"] = "Dashboard Charge Interest Now Click";
    MixpanelEvents["DashboardSendStatementNowClick"] = "Dashboard Send Statement Now Click";
    MixpanelEvents["DashboardIssueLateFeeNowClick"] = "Dashboard Issue Late Fee Now Click";
    MixpanelEvents["DashboardSendSmsNowClick"] = "Dashboard Send SMS Now Click";
    MixpanelEvents["ContactPageChargeInterestNowClick"] = "Contact Page Charge Interest Now Click";
    MixpanelEvents["ContactPageSendStatementNowClick"] = "Contact Page Send Statement Now Click";
    MixpanelEvents["InvoicePageSendReminderNowClick"] = "Invoice Page Send Reminder Now Click";
    MixpanelEvents["InvoicePageIssueLateFeeNowClick"] = "Invoice Page Issue Late Fee Now Click";
    MixpanelEvents["InvoicePageSmsNowClick"] = "Invoice Page SMS Now Click";
    MixpanelEvents["InvoicesListPageIssueLateFeeNowClick"] = "Invoices List Page Issue Late Fee Now Click";
    MixpanelEvents["PreviewAutomateThisLinkClick"] = "Preview Automate This Link Click";
    MixpanelEvents["LoginFromXeroAppStore"] = "LoginFromXeroAppStore";
    MixpanelEvents["BulkAdhocAction"] = "BulkAdhocAction";
})(MixpanelEvents || (MixpanelEvents = {}));
export var MixpanelGroupKeys;
(function (MixpanelGroupKeys) {
    MixpanelGroupKeys["OrganisationId"] = "organisation_id";
})(MixpanelGroupKeys || (MixpanelGroupKeys = {}));
export var MixpanelEventProperty;
(function (MixpanelEventProperty) {
    MixpanelEventProperty["ActionType"] = "action_type";
    MixpanelEventProperty["Location"] = "location";
})(MixpanelEventProperty || (MixpanelEventProperty = {}));
// Basically just pages in the app
export var MixpanelLocationTypes;
(function (MixpanelLocationTypes) {
    MixpanelLocationTypes["Dashboard"] = "dashboard";
    MixpanelLocationTypes["InvoiceTable"] = "invoice_table";
    MixpanelLocationTypes["InvoicePage"] = "invoice_page";
    MixpanelLocationTypes["ContactTable"] = "contact_table";
    MixpanelLocationTypes["ContactPage"] = "contact_page";
})(MixpanelLocationTypes || (MixpanelLocationTypes = {}));
//# sourceMappingURL=mixpanel.js.map